export const PAYMENT_FLOW_REDESIGN_FLAG = "PYMT-2958_payment_flow_redesign";

export function isUIFlagEnabled(flags: Record<string, boolean> | undefined, key: string): boolean {
  return flags?.[key] === true;
}
